<template>
    <el-main>
        <div class="breadcrumb-container">
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item>Settings</el-breadcrumb-item>
                <el-breadcrumb-item>Departments</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-row style="margin-top: 24px">
            <el-col :span="18">
                <div class="main-title">
                    Department List
                </div>
            </el-col>
            <el-col :span="6" class="text-right">
                <el-button type="primary" size="small" icon="el-icon-plus" @click="isEdit = false; resetForm(); showCreateDialog = true">New Department</el-button>
            </el-col>
        </el-row>

        <el-row type="flex" style="margin-top:24px">
            <el-col :span="24">
                <el-card class="box-card">
                    <el-row style="margin-bottom: 18px" :gutter="15">
                        <el-col :span="4" :offset="16">
                            <status-filter v-model="query.status" @change="queryStatusChanged()"></status-filter>
                        </el-col>
                        <el-col :span="4">
                            <el-input v-model="query.search" size="small" placeholder="Name" class="filter-item" @keyup.enter.native="search"/>
                        </el-col>
                    </el-row>

                    <el-table
                            v-loading="loading"
                            :data="departments"
                            stripe
                            @sort-change="sortChange"
                            :default-sort="query.sort"
                            style="width: 100%">
                        <el-table-column
                                prop="id"
                                label="ID"
                                width="80"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="name"
                                label="Name"
                                width="180"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="description"
                                label="Description"
                                sortable>
                        </el-table-column>
                        <el-table-column
                                prop="active"
                                label="Status"
                                sortable>
                            <template slot-scope="scope">
                                {{scope.row.active ? 'Active':'Inactive'}}
                            </template>
                        </el-table-column>
                        <el-table-column label="Actions">
                            <template slot-scope="scope">
                                <el-button size="mini" icon="el-icon-edit" @click="isEdit = true; edit(scope.$index, scope.row)"></el-button>
                            </template>
                        </el-table-column>
                    </el-table>

                    <pagination v-show="query.total>0" :total="query.total" :page.sync="query.page" :limit.sync="query.limit" @pagination="searchData" />
                </el-card>
            </el-col>
        </el-row>
        <el-dialog v-bind:title="dialogTitle" :visible.sync="showCreateDialog">
            <el-form :model="form" ref="dataForm" :rules="dataRules" v-loading="saving">
                <el-form-item :required="true" label="Name" :label-width="formLabelWidth" prop="name">
                    <el-input v-model="form.name"></el-input>
                </el-form-item>
                <el-form-item label="Description" :label-width="formLabelWidth" prop="description">
                    <el-input type="textarea" v-model="form.description"></el-input>
                </el-form-item>
                <el-form-item >
                    <div class="switch-label" style="width: 108px;" >Active</div> <el-switch v-model="form.active"></el-switch>
                </el-form-item>
            </el-form>
            <span slot="footer" class="dialog-footer">
                <el-button size="small" @click="showCreateDialog = false">Cancel</el-button>
                <el-button size="small" type="primary" @click="save()">Save</el-button>
            </span>
        </el-dialog>
    </el-main>
</template>

<script>
import _ from "lodash";
import api from "@/services/api/WRCService"
import Pagination from "@/components/Pagination"
import StatusFilter from '@/components/StatusFilter'

export default {
    components: { Pagination, StatusFilter },
    data: function() {
        var validateName = (rule, value, callback) => {
            if (!value) {
                callback(new Error('Please enter Name'));
            } else {
                callback();
            }
        };
        return {
            dataRules: {
                name: [
                    { validator: validateName, trigger: 'blur' }
                ]
            },
            showCreateDialog: false,
            formLabelWidth: '120px',
            form: {
              name: '',
              description: '',
              active: true
            },
            dialogTitle: 'New Department',
            saving: false,
            loading: false,
            countryLoading: false,
            departments: [],
            isEdit: false,
            query: {
                total: 0,
                page: 0,
                limit: 10,
                pageSize: 0,
                search: null,
                status: 'Active',
                sort: {
                    prop: 'id',
                    order: 'ascending',
                    orderVal: 'asc'
                }
            }
        }
    },
    watch: {
        form : function() {
            if (_.isUndefined(this.form.id)) {
                this.dialogTitle = 'New Department';
            } else {
                this.dialogTitle = 'Edit Department';
            }
        }
    },
    methods:{
        search() {
            this.query.page = 1;
            this.searchData();
        },
        searchData() {
            this.loading = true;

            var active = null

            if (this.query.status === "Active") {
                active = true
            } else if (this.query.status === "Inactive") {
                active = false
            }

            api.getDepartments(this.query.search, {
                page: 0,
                size: 100
            }, active).then(({ data }) => {

                this.departments.splice(0, this.departments.length);
                this.departments.push(...data.data.items);
                this.query.total = data.page.totalElements;
                //this.pagination.total = data.total;
                //this.pagination.currentPage = data.currentPage;
            }).catch(() => {}).then(() => {
                this.loading = false;
            });
        },
        queryStatusChanged() {
            this.search()
        },
        sortChange(data) {
            const { prop, order } = data;
            if(prop == null){
                this.query.sort = {
                    prop: 'id',
                    order: 'ascending',
                    orderVal: 'asc'
                };
            }else {
                this.query.sort = {
                    prop: prop,
                    order: order,
                    orderVal: order === 'ascending' ? 'asc' : 'desc'
                }
            }

            this.searchData()
        },
        edit(idx, data) {

            this.form = {
                id: data.id,
                name: data.name,
                description: data.description,
                active: data.active
            };

            this.showCreateDialog = true;
        },
        resetForm() {
            this.saving = false;

            this.form = {
              description: '',
              active: true
            }

            setTimeout(() => {
                if (!_.isUndefined(this.$refs['dataForm'])) {
                    this.$refs['dataForm'].clearValidate();
                }
            }, 1);
        },
        save() {
            this.$refs['dataForm'].validate((valid) => {
                if (valid) {
                    this.saving = true;
                    if (_.isUndefined(this.form.id)) {
                        api.createDepartments(this.form).then(() => {
                            this.$message({
                              message: 'Successfully added Department.',
                              type: 'success'
                            });
                        }).catch(() => {}).then(() => {
                            this.saving = false;
                            this.searchData();
                            this.showCreateDialog = false;
                        });
                    } else {
                        let params = {
                            departmentId: this.form.id,
                            name: this.form.name,
                            description: this.form.description,
                            active: this.form.active
                        }

                        api.updateDepartment(params).then(() => {
                            this.$message({
                              message: 'Successfully updated Department.',
                              type: 'success'
                            });
                        }).catch(() => {}).then(() => {
                            this.saving = false;
                            this.searchData();
                            this.showCreateDialog = false;
                        });
                    }
                } else {
                    console.log('error submit!!');
                    return false;
                }
            });

        }
    },
    mounted() {
        this.query.page = 1;
        this.searchData();
    }
}
</script>
